import { initHttpClient, getHttpClient } from "@repo/api/http";
import toast from "react-hot-toast";
import { appConfig } from "@/config/app-config";
import { UserManager } from "@/service/user-manager";
import { VersionManager } from "@/utils/version-manager";
import { getQueryVariable } from "@/utils/utils";

initHttpClient({
  apiRoot: appConfig.apiRoot,
  // 根路由 beforeLoad 已把 bridge / URL 解析出的 token 写入 sessionStorage，这里只兜底 URL
  getToken: () => UserManager.getToken() || getQueryVariable("t") || "",
  getVersion: () => VersionManager.getCurrentVersion(),
  // AuthProvider 挂载后会覆盖为「清 session + 同步 React 状态」
  logoutCallback: () => {
    UserManager.removeSession();
  },
  onForbidden: () => {
    toast.error("无权限");
  },
  showLog: false,
});

export default getHttpClient();
